import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    DatePicker,
} from 'antd';
import time from '../../utils/time'
import chart from '../../utils/chart'
import moment from "moment";
import useQueryUpdater from './useQueryUpdater'
import styles from './styles'
import PropTypes from 'prop-types'
import FilterContext from './FilterContext'

const { RangePicker } = DatePicker;

const DateRangeSelect = () => {

    const {
        filterState,
        handleFilterChange,
        tableName,
        timeColumn,
        state,
        setState
    } = useContext(FilterContext)

    /* useState */
    // const [dateRange, setDateRange] = useState(undefined)


    /* useQueryUpdater - custom hook */
    // const queryUpdater = useQueryUpdater()


    /* useCallback */
    /**
     * @function updateTimeDimensionQuery updates dashboard data with new time dimensions 
     * @param {Array} timeDimRange [startdate, enddate]
     * @returns {Object} updated dashboard data 
     */
    // const updateTimeDimensionQuery = useCallback((timeDimRange) => {
    //     // get dashboard data from local storage
    //     let updatedData = {}
    //     updatedData['dashboardItems'] = chart.getLocalDashboardItems()
    //     updatedData.dashboardItems.forEach(async (dashboardItem) => {
    //         // update each dashboard item and update its query
    //         let updatedVizState = JSON.parse(dashboardItem.vizState)
    //         updatedVizState.query.timeDimensions = time.mapDateRangeToTimeDimensions(timeDimRange, tableName, timeColumn, updatedVizState.query.timeDimensions)
    //         dashboardItem.vizState = JSON.stringify(updatedVizState)
    //         await (await queryUpdater).updateQuery(dashboardItem)
    //     })

    //     return updatedData
    // })

    /**
     * @function handleDateRangeChange called when the user updates the time period
     * @param {Array} value [moment(startdate), moment(enddate)]
     */
    // const handleDateRangeChange = useCallback((value) => {
    //     // update state
    //     // setDateRange(value)
    //     let timeDimRange
    //     // update cached time period
    //     if (value !== null) {
    //         timeDimRange = value.map((d) => (
    //             (moment(d.format('YYYY-MM-DD')))._i
    //         ))
    //         time.setDateRange(timeDimRange)
    //     } else time.setDateRange()

    //     // @function updateTimeDimensionQuery
    //     const updatedData = updateTimeDimensionQuery(timeDimRange)
    //     // update local storage and cache with updated dashboard data
    //     // chart.setLocalDashboardItems(updatedData.dashboardItems)
    //     // chart.setDashboard(updatedData)
    // })


    /* useEffect */
    /** 
     * @function useEffect runs only on first render
     */
    useEffect(() => {
        // get dashboard data from local storage 
        // let dashboardItems = chart.getLocalDashboardItems()
        // update range picker with current time dimensions
        // let dValues = time.mapTimeDimensionsToDateRange(dashboardItems[0])
        // setDateRange(dValues)

    }, [])

    useEffect(() => {
        if (state.reset) {
            handleFilterChange('date_range', [])
            // handleDateRangeChange(null)
        }
    }, [state])

    return (
        <>
            <RangePicker
                style={styles.inputSize()}
                onChange={(value) => { handleFilterChange('date_range', value) }}
                value={filterState.date_range}
                format={'DD MMM YYYY'}
            />
        </>
    )
}

DateRangeSelect.propTypes = {}
DateRangeSelect.defaultProps = {}

export default DateRangeSelect